export class TrainingVideo {
    public name: string = '';
    public url: string = '';
}